// src/hooks/useHasPermission.js   ← NEW FILE (Create this)
import { useSelector } from 'react-redux';

export const useHasPermission = () => {
  const permissions = useSelector((state) => state.permission?.myPermissions || []);

  const hasPermission = (resource) => {
    if (!resource) return true; // No resource = always show (for parents)
    const perm = permissions.find(p => p.resource === resource);
    return perm ? (perm.can_read || perm.can_create || perm.can_update || perm.can_delete) : false;
  };

  return hasPermission;
};